export default __webpack_public_path__ + "static/media/plusDarkBlue.2b57870d.svg";